import React, { Component } from 'react'
import {
  saveFiles,
  createBranchAndSaveFiles,
 } from './../../../../store/branches/actions'
import { connect } from 'react-redux'
import BranchSave from './BranchSave'
import Saving from './Saving'

const mapStateToProps = (state, props) => {
  var repositoryId = props.repositoryId
  var repo = state.repositories[repositoryId]
  var branchId = repo.selectedBranch
  var branch = state.branches[branchId]
  var unsavedFiles = []
  if (branch.schema && state.uncommitted[branch.schema]){
    var file = state.files[branch.schema]
    unsavedFiles.push(file)
  }
  return {
    branchId,
    unsavedFiles,
    saving: state.loading[`${branchId}-saving`],
    repositoryId,
  }
}

const mapDispatchToProps = dispatch => ({
  saveFiles: (branchId, files, commitMessage) =>
    dispatch(saveFiles(branchId, files, commitMessage)),
  createBranchAndSaveFiles:
    (currentBranchId, newBranchName, files, commitMessage, repositoryId) =>
    dispatch(createBranchAndSaveFiles(currentBranchId, newBranchName, files, commitMessage, repositoryId)),
})

class BranchSaveContainer extends Component {

  componentWillReceiveProps = (newProps) => {
    if ((newProps.saving == false && this.props.saving == true)
    // Or the branch id changes on save
    || newProps.branchId != this.props.branchId){
      this.props.onClose()
    }
  }

  onSave = (commitMessage) => {
    const { branchId, unsavedFiles, saveFiles } = this.props
    saveFiles(branchId, unsavedFiles, commitMessage)
  }

  onSaveNewBranch = (newBranchName, commitMessage) => {
    const {
      branchId: currentBranchId,
      unsavedFiles: files,
      createBranchAndSaveFiles,
      repositoryId,
    } = this.props
    createBranchAndSaveFiles(currentBranchId, newBranchName, files, commitMessage, repositoryId)
  }

  render = () => {
    if (this.props.saving)
      return <Saving />
    return <BranchSave
      value={this.props.value}
      onSave={this.onSave}
      onSaveNewBranch={this.onSaveNewBranch}
      onClose={this.props.onClose}
    />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchSaveContainer)


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/SaveBranchDialog/BranchSave/Container.js